var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetCombo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.83,
    height: 17.316
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bet-combo_svg__Icon_-_Combo_v3",
    "data-name": "Icon - Combo v3",
    transform: "translate(.089 .296)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "bet-combo_svg__Path_5682",
    "data-name": "Path 5682",
    d: "M6.87 8.92a5.414 5.414 0 00-3.952-2.17H.75",
    transform: "translate(-.339 -3.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-combo_svg__Path_5683",
    "data-name": "Path 5683",
    d: "M18.58 6.75h-4.1c-3.614 0-5.783 5.06-5.783 5.06s-2.168 5.06-5.783 5.06H.75",
    transform: "translate(-.339 -3.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-combo_svg__Path_5684",
    "data-name": "Path 5684",
    d: "M21.05 23.254A5.407 5.407 0 0025 25.421h4.1",
    transform: "translate(-10.857 -11.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-combo_svg__Path_5685",
    "data-name": "Path 5685",
    d: "M31.75.75l2.891 2.891-2.891 2.892",
    transform: "translate(-16.4 -.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-combo_svg__Path_5686",
    "data-name": "Path 5686",
    d: "M31.75 21.75l2.891 2.891-2.891 2.892",
    transform: "translate(-16.4 -11.219)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC44MyIgaGVpZ2h0PSIxNy4zMTYiIHZpZXdCb3g9IjAgMCAxOC44MyAxNy4zMTYiPgogIDxnIGlkPSJJY29uXy1fQ29tYm9fdjMiIGRhdGEtbmFtZT0iSWNvbiAtIENvbWJvIHYzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjA4OSAwLjI5NikiPgogICAgPHBhdGggaWQ9IlBhdGhfNTY4MiIgZGF0YS1uYW1lPSJQYXRoIDU2ODIiIGQ9Ik02Ljg3LDguOTJBNS40MTQsNS40MTQsMCwwLDAsMi45MTgsNi43NUguNzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjMzOSAtMy40NDgpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81NjgzIiBkYXRhLW5hbWU9IlBhdGggNTY4MyIgZD0iTTE4LjU4LDYuNzVoLTQuMWMtMy42MTQsMC01Ljc4Myw1LjA2LTUuNzgzLDUuMDZzLTIuMTY4LDUuMDYtNS43ODMsNS4wNkguNzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjMzOSAtMy40NDgpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njg0IiBkYXRhLW5hbWU9IlBhdGggNTY4NCIgZD0iTTIxLjA1LDIzLjI1NEE1LjQwNyw1LjQwNywwLDAsMCwyNSwyNS40MjFoNC4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAuODU3IC0xMS45OTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njg1IiBkYXRhLW5hbWU9IlBhdGggNTY4NSIgZD0iTTMxLjc1Ljc1bDIuODkxLDIuODkxTDMxLjc1LDYuNTMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYuNCAtMC4zMzkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njg2IiBkYXRhLW5hbWU9IlBhdGggNTY4NiIgZD0iTTMxLjc1LDIxLjc1bDIuODkxLDIuODkxTDMxLjc1LDI3LjUzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2LjQgLTExLjIxOSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgBetCombo as ReactComponent };